import { useRef, useState } from 'react'
import { useUserStore } from 'src/stores/user'
import { Avatar, Box, Button, Divider, Hidden, Popover } from '@mui/material'
import {
  MenuUserBox,
  UserBoxButton,
  UserBoxDescription,
  UserBoxLabel,
  UserBoxText,
} from './UserBox.styled'
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone'
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone'
import { useLogout } from 'src/utils/user-connection'
import { useAuth0 } from '@auth0/auth0-react'
import { getRoleName } from 'src/utils/roles'

function HeaderUserbox() {
  const { logOutUser } = useLogout()
  const ref = useRef<any>(null)
  const [isOpen, setOpen] = useState<boolean>(false)
  const { logout, user } = useAuth0()
  const { adminRole } = useUserStore()

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
    logOutUser()
  }

  const handleOpen = (): void => {
    setOpen(true)
  }

  const handleClose = (): void => {
    setOpen(false)
  }

  if (!user) {
    handleLogout()
  }

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" src={user.picture} />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxDescription variant="body2">{user.email}</UserBoxDescription>
            <UserBoxLabel variant="body1">{getRoleName(adminRole)}</UserBoxLabel>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" src={user.picture} />
          <UserBoxText>
            <UserBoxDescription variant="body2">{user.email}</UserBoxDescription>
            <UserBoxLabel variant="body1">{getRoleName(adminRole)}</UserBoxLabel>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />

        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={handleLogout}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  )
}

export default HeaderUserbox
